import Rotas from '../src/main/Rotas'
import '../src/pages/css/custom2.css'
import ProvedorAutenticacao from '../src/main/ProvedorAutenticacao'

function App() {
  
  const usuarioLogadoString = localStorage.getItem('_usuario_logado')
  const usuarioLogado = JSON.parse(usuarioLogadoString)


  return (
    <>
      <div>
        <ProvedorAutenticacao>
          <Rotas/>
        </ProvedorAutenticacao>
      </div>
    </>
  );
}

export default App;
